import {useModals} from "@mantine/modals";
import {useNavigate} from "react-router-dom";
import React from "react";
import CreateLocationForm from "../../components/forms/location/CreateLocationForm";

export default function useCreateLocation(navigateAway: boolean = false) {
    const modals = useModals();
    const navigate = useNavigate();

    const openModal = () => {
        const modalId = modals.openModal({
            size: "xl",
            title: 'Create location',
            closeOnClickOutside: false,
            children: (
                <>
                    <CreateLocationForm onClose={() => closeModal(modalId)} />
                </>
            ),
        });
    };

    const closeModal = (id: string) => {
        modals.closeModal(id)
        navigateAway && navigate(`/locations`)
    }

    return {
        openModal
    }
}
